import * as React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import AppTheme from '../shared-theme/AppTheme';
import Hero from './components/Hero';
import Highlights from './components/Highlights';
import Footer from './components/Footer';

export default function MainPage(props: { disableCustomTheme?: boolean }) {
  return (
    <AppTheme {...props}>
      <CssBaseline enableColorScheme />
      <Hero />
      <div>
        <Divider />
        <Highlights />
        <Divider />
        <Footer />
      </div>
    </AppTheme>
  );
}
